module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_c('router-link', {
    attrs: {
      "to": {
        name: 'stacks'
      }
    }
  }, [_vm._v("stacks")])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-nav"
  }, [(_vm.user) ? _c('div', [(_vm.user.imageUrl) ? _c('img', {
    attrs: {
      "src": _vm.user.imageUrl,
      "alt": _vm.user.userTitle
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.userTitle))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signOut($event)
      }
    }
  }, [_vm._v("\n          sign out\n        ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-378c8cd9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
// module id = 196
// module chunks = 1